let skipNextPop = false;

export const skipTutorialAbortOnNextPop = () => {
    skipNextPop = true;
};

export const consumeSkipNextPop = () => {
    const v = skipNextPop;
    if (v) skipNextPop = false;
    return v;
};
